// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"0576d9d4","500":"684797af","850":"80141f51"}[chunkId] + ".chunk.css";
};